import React from 'react'
import { Container } from 'react-bootstrap'
import CardCTA from '~components/CardCTA'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import * as s from './Farms.module.scss'
import { bridges, farms, stakes } from './const'

const Farms = () => {
  const { t } = useTranslation()

  return (
    <section id="farms" className={s.farms_wrapper}>
      <Container className={s.farms}>
        <div className={s.farmsBridgesStake} id="farms">
          <div className={s.wrapper}>
            <div className={s.content}>
              <h3>{t('farms')}</h3>
              <p className={s.blockDescription}>{t('farmsDesc')}</p>
              {farms.map((farm) => (
                <CardCTA
                  key={farm.name}
                  title={farm.name}
                  icon={farm.icon}
                  url={farm.url}
                />
              ))}
            </div>

            <div className={s.content} id="stake">
              <h3>{t('stake')}</h3>
              <p className={s.blockDescription}>{t('stakeDesc')}</p>
              {stakes.map((stake) => (
                <CardCTA
                  key={stake.name}
                  title={stake.name}
                  icon={stake.icon}
                  url={stake.url}
                />
              ))}
            </div>

            <div className={s.content}>
              <h3>{t('bridges')}</h3>
              <p className={s.blockDescription}>{t('bridgesDesc')}</p>
              {bridges.map((bridge) => (
                <CardCTA
                  key={bridge.name}
                  title={bridge.name}
                  icon={bridge.icon}
                  url={bridge.url}
                />
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Farms
